export enum DeviceType{
  Android,
  iOS,
  Browser,
  Unknown
}
